import React from 'react';

const CVE_TOOLTIP = 'CVE matching is planned (APD-1650) and not yet available';

/**
 * Reserved, wired-off CVE column. Keeps the software layout stable so the real
 * risk data can drop in once the vulnerability matcher (APD-1650) lands.
 */
const CveCellRenderer: React.FC = () => (
    <span className="inventory-cve" title={CVE_TOOLTIP}>
        <span className="inventory-cve__dot" />
        Planned
    </span>
);

export default CveCellRenderer;
